import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { messages } from '../../../../../messages';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseTextElement, toFormattedTextProps } from '../common';
var AssignedToElement = function AssignedToElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toFormattedTextProps(messages.assigned_to, context.assignedTo) : null;
  return data ? /*#__PURE__*/React.createElement(BaseTextElement, _extends({}, data, props, {
    name: ElementName.AssignedTo
  })) : null;
};
export default AssignedToElement;